import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Heading from '../components/heading/Heading';
import Text from './../components/text/Text';

const Signed = ( props ) => {
    const dispatch = useDispatch()
    
    useEffect(() => {
        const asyncFc = async () => {
            const params = new URLSearchParams(window.location.search);
            const fileName = params.get("signedPdf");
            if (fileName) {
                // console.log(`https://server-nodejs.grenke-calculator.ae/signed/${fileName}`);
                
                window.localStorage.setItem("signed_url_file", `https://server-nodejs.grenke-calculator.ae/signed/signed_${fileName}.pdf`);
                window.localStorage.setItem("signed_url", `https://server-nodejs.grenke-calculator.ae/api/pdf/${fileName}`);
            }
        }
        asyncFc()
    }, []);

    return (
        <section className="form">
            <div className="container thanks-container" style={{ marginTop: "30px" }}>
                <div className="thanks" style={{ height: "560px", display: "flex", alignItems: "center", justifyContent: "center", marginTop: "0" }}>
                    <div className="text-box" style={{ height: "560px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {/* <Heading title={`The document has been successfully signed and submitted for review. Continue filling out the application below.`} /> */}
                        <Text text={ `<h1>The document has been successfully signed and submitted for review.</h1><h3 style="margin-top: 10px">Continue filling out the application below.</h3>` } />
                    </div>
                </div>
            </div>
        </section>
    )
    
}

export default Signed;